import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import "./style.scss";
import { Nav } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import routes from "routes.js";
import { Modal } from "react-bootstrap";

// Declare the component 
function Sidebar(props) {

  const { searchProps } = props; // Extract the `searchProps` object
  const { search, setSearch } = searchProps; // Extract `search` and `setSearch` from `searchProps`

  console.log(search, "search, setSearch");
  const sidebar = useRef(null); // Reference for sidebar
  const [brandName, setBrandName] = useState(""); // State for brand name
  const [show, setShow] = useState(false); // Modal state

  const router = useLocation();
  const history = useHistory();
  
  // Handle modal show and close
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Initialize PerfectScrollbar for Windows platform
  useEffect(() => {
    let ps;
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return () => {
      if (ps) {
        ps.destroy(); // Cleanup when the component is unmounted
      }
    };
  }, []);

  const handleLogOut = () => {
    localStorage.clear();
    history.push("/adminlogin/dashboard");
  };

  // Get the brand name based on the current route
  const getBrand = () => {
    routes.forEach((prop) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setBrandName(prop.name);
      }
    });
  };

  useEffect(() => {
    getBrand();
  }, []); // Only call once after the first render

  // Toggle sidebar visibility
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };


  const logoutHandle = () => {
    localStorage?.removeItem("token");
    localStorage?.removeItem("refreshToken");
    localStorage?.removeItem("metadataHashes");
    localStorage?.removeItem("fileHashes");

    history?.push("/adminlogin");

  }

  return (
    <>
      <div
        className="sidebar"
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo for-mobilesidebar-sm">
          <Link to="/clinic/dashboard" className="simple-text logo-mini">
            <div className="logo-img text-left">
              <img src="\logo.svg" alt="react-logo" />
            </div>
          </Link>
          <img
            src="/assets/images/Close.svg"
            alt="img"
            className="img-fluid img-close d-none"
            onClick={openSidebar}
          />
        </div>
        <div className="mblnavbtns d-none">
          <div className="navright">
            <div className="inputdiv">
              <input
                type="text"
                id="fname"
                name="fname"
                className="inputnavvv"
                placeholder="Search res"
                onChange={(e) => setSearch(e?.target?.value)}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                className="imgwhitesearch"
              >
                <path
                  d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
                  stroke="#7E7E7E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.75 15.7498L12.4875 12.4873"
                  stroke="#7E7E7E"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <button className="whitebtn" onClick={handleShow}>
              <div className="whitebtnimg">
                <img
                  src="/assets/dummyassets/user.svg"
                  alt="btninnerimg"
                  className="btninnerimg"
                />
              </div>
              <p className="btninnerpara">Administration</p>
            </button>
          </div>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            <li>
              <NavLink
                to="/admin/dashboard"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M4.16663 8.49577H5.83329C7.49996 8.49577 8.33329 7.66243 8.33329 5.99577V4.3291C8.33329 2.66243 7.49996 1.8291 5.83329 1.8291H4.16663C2.49996 1.8291 1.66663 2.66243 1.66663 4.3291V5.99577C1.66663 7.66243 2.49996 8.49577 4.16663 8.49577Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.1666 8.49577H15.8333C17.5 8.49577 18.3333 7.66243 18.3333 5.99577V4.3291C18.3333 2.66243 17.5 1.8291 15.8333 1.8291H14.1666C12.5 1.8291 11.6666 2.66243 11.6666 4.3291V5.99577C11.6666 7.66243 12.5 8.49577 14.1666 8.49577Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.1666 18.4958H15.8333C17.5 18.4958 18.3333 17.6624 18.3333 15.9958V14.3291C18.3333 12.6624 17.5 11.8291 15.8333 11.8291H14.1666C12.5 11.8291 11.6666 12.6624 11.6666 14.3291V15.9958C11.6666 17.6624 12.5 18.4958 14.1666 18.4958Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4.16663 18.4958H5.83329C7.49996 18.4958 8.33329 17.6624 8.33329 15.9958V14.3291C8.33329 12.6624 7.49996 11.8291 5.83329 11.8291H4.16663C2.49996 11.8291 1.66663 12.6624 1.66663 14.3291V15.9958C1.66663 17.6624 2.49996 18.4958 4.16663 18.4958Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p>Dashboard</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/admin/dashboard" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5" r="4" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>


              </NavLink>
            </li>

            <li>
              <Link
                to="/admin/myproducts" // Correct the "to" attribute by enclosing the URL in quotes
                className={
                  "nav-link " +
                  (router.pathname === "/admin/myproducts" ? "active" : "")
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" className="iconns">
                      <path d="M7.63338 9.22126C7.55005 9.21292 7.45005 9.21292 7.35838 9.22126C5.37505 9.15459 3.80005 7.52959 3.80005 5.52959C3.80005 3.48792 5.45005 1.82959 7.50005 1.82959C9.54172 1.82959 11.2 3.48792 11.2 5.52959C11.1917 7.52959 9.61672 9.15459 7.63338 9.22126Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.675 3.49609C15.2916 3.49609 16.5916 4.80443 16.5916 6.41276C16.5916 7.98776 15.3417 9.27109 13.7833 9.32943C13.7167 9.32109 13.6417 9.32109 13.5667 9.32943" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3.4666 12.2961C1.44993 13.6461 1.44993 15.8461 3.4666 17.1878C5.75827 18.7211 9.5166 18.7211 11.8083 17.1878C13.8249 15.8378 13.8249 13.6378 11.8083 12.2961C9.52494 10.7711 5.7666 10.7711 3.4666 12.2961Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M15.2834 16.8296C15.8834 16.7046 16.4501 16.4629 16.9168 16.1046C18.2168 15.1296 18.2168 13.5213 16.9168 12.5463C16.4584 12.1963 15.9001 11.9629 15.3084 11.8296" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="">Users</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/admin/myproducts" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/badgesandpoints" // Enclosed the URL path in quotes
                className={
                  "nav-link " +
                  (router.pathname === "/admin/badgesandpoints" ? "active" : "")
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" className="iconns">
                      <path d="M2.5 18.4961H17.5" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M4.66665 7.14624H3.33333C2.875 7.14624 2.5 7.52124 2.5 7.97957V15.1629C2.5 15.6212 2.875 15.9962 3.33333 15.9962H4.66665C5.12498 15.9962 5.49998 15.6212 5.49998 15.1629V7.97957C5.49998 7.52124 5.12498 7.14624 4.66665 7.14624Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M10.6666 4.48804H9.33333C8.875 4.48804 8.5 4.86304 8.5 5.32137V15.163C8.5 15.6214 8.875 15.9964 9.33333 15.9964H10.6666C11.125 15.9964 11.5 15.6214 11.5 15.163V5.32137C11.5 4.86304 11.125 4.48804 10.6666 4.48804Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M16.6666 1.82959H15.3333C14.875 1.82959 14.5 2.20459 14.5 2.66292V15.1629C14.5 15.6213 14.875 15.9963 15.3333 15.9963H16.6666C17.125 15.9963 17.5 15.6213 17.5 15.1629V2.66292C17.5 2.20459 17.125 1.82959 16.6666 1.82959Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="">Projects</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/admin/badgesandpoints" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>


              </Link>
            </li>

            {/* <li>
              <Link
                to="/admin/editprofile"
                className={`nav-link ${router.pathname === "/admin/editprofile" ? "active" : ""}`}
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M11.05 3.16275L4.20829 10.4044C3.94996 10.6794 3.69996 11.2211 3.64996 11.5961L3.34162 14.2961C3.23329 15.2711 3.93329 15.9378 4.89996 15.7711L7.58329 15.3128C7.95829 15.2461 8.48329 14.9711 8.74162 14.6878L15.5833 7.44609C16.7666 6.19609 17.3 4.77109 15.4583 3.02942C13.625 1.30442 12.2333 1.91275 11.05 3.16275Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.90845 4.37108C10.2668 6.67108 12.1334 8.42941 14.4501 8.66275"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.5 18.4961H17.5"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className="">Edit Profile</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/admin/editprofile" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </Link>
            </li> */}

            {/* 
<li>
  <Link
    to="/admin/productscatalog" // Enclosed the URL path in quotes
    className={
      "nav-link " + (brandName === "Products Catalog" || brandName === 'Products Catalog Details' ? "active" : "")
    }
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="iconns">
      <path d="M2.6416 6.20001L9.99993 10.4583L17.3083 6.22501" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 18.0083V10.45" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.27454 2.06667L3.82454 4.53333C2.81621 5.09167 1.99121 6.49167 1.99121 7.64167V12.35C1.99121 13.5 2.81621 14.9 3.82454 15.4583L8.27454 17.9333C9.22454 18.4583 10.7829 18.4583 11.7329 17.9333L16.1829 15.4583C17.1912 14.9 18.0162 13.5 18.0162 12.35V7.64167C18.0162 6.49167 17.1912 5.09167 16.1829 4.53333L11.7329 2.05833C10.7745 1.53333 9.22454 1.53333 8.27454 2.06667Z" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <p className="">Products Catalog</p>
    {brandName === "Products Catalog" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="10"
        viewBox="0 0 9 10"
        fill="none"
        className="active-indicator"
      >
        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
      </svg>
    )}
  </Link>
</li> */}
          </Nav>
          <div className="logout">
            {/* <Link to="" className="nav-link"> */}
            <button className="btn-logout" onClick={() => logoutHandle()}>
              Log Out
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>

      {/* Modal for user */}
      <Modal className="ambmodalmain" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Your Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="connect">Please connect your crypto wallet.</p>
            <div className="meta lastmeta">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div className="meta">
              <div className="inermeta">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M6.11994 9.12561C10.1953 4.95813 16.8047 4.95813 20.8801 9.12561L21.3701 9.62382C21.5765 9.83253 21.5765 10.1692 21.3701 10.3779L19.6936 12.0947C19.5904 12.1957 19.4292 12.1957 19.326 12.0947L18.649 11.4012C15.8053 8.49274 11.1947 8.49274 8.35105 11.4012L7.62884 12.1418C7.52566 12.2428 7.36446 12.2428 7.26128 12.1418L5.57828 10.4317C5.37194 10.223 5.37194 9.88639 5.57828 9.67768L6.11994 9.12561ZM24.3492 12.6737L25.8452 14.202C26.0516 14.4107 26.0516 14.7473 25.8452 14.956L19.1068 21.8435C18.9004 22.0522 18.5716 22.0522 18.3717 21.8435L13.5935 16.9556C13.5419 16.9017 13.4581 16.9017 13.4065 16.9556L8.62832 21.8435C8.42198 22.0522 8.09311 22.0522 7.89322 21.8435L1.15476 14.956C0.948414 14.7473 0.948414 14.4107 1.15476 14.202L2.65076 12.6737C2.85711 12.465 3.18597 12.465 3.38587 12.6737L8.16404 17.5615C8.21563 17.6154 8.29946 17.6154 8.35105 17.5615L13.1292 12.6737C13.3356 12.465 13.6644 12.465 13.8643 12.6737L18.6425 17.5615C18.6941 17.6154 18.7779 17.6154 18.8295 17.5615L23.6077 12.6737C23.814 12.465 24.1429 12.465 24.3492 12.6737Z"
                    fill="#007FFF"
                  />
                </svg>
                <p> Connect Wallet</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Sidebar;
